import { GenericZodSchemaFormValidation, ZodFormValidationDisplay } from "@lib/validation/utils";
import { availabilitySchema, cvUploadSchema, personalInfoSchema, writingCentreSchema } from "./types";
import { ReCAPTCHA } from "@lib/recaptcha";

export declare var grecaptcha: ReCAPTCHA;

function NextStep(event: Event)
{
    const button = event.currentTarget as HTMLButtonElement;
    const element = button.closest('.steps') as HTMLDivElement;
    const validationErrors = document.querySelectorAll('.field-validation-error');
    const nextElement = document.querySelector(`[data-step="${parseInt(element.dataset.step ?? "0") + 1}"]`) as HTMLDivElement;
    const form = document.getElementById('regform') as HTMLFormElement;
    const currentStep = document.querySelector(`[data-step-nav="${parseInt(element.dataset.step ?? "0")}"]`);
    const nextStep = document.querySelector(`[data-step-nav="${parseInt(element.dataset.step ?? "0") + 1}"]`);

    validationErrors.forEach(item => item.remove());

    try {
        switch (nextElement.dataset.step) {
            case "2": {
                const data = Object.fromEntries(new FormData(form));
                const schema = personalInfoSchema.parse(data);
                break;
            }
            case "3": {
                const data = Object.fromEntries(new FormData(form));
                const schema = availabilitySchema.parse(data);
                break;
            }
            case "4": {
                const data = Object.fromEntries(new FormData(form));
                const schema = cvUploadSchema.parse(data);
                break;
            }
        }

        currentStep?.classList.add('step-register__step--completed');
        nextStep?.classList.add('step-register__step--active');
    } catch (error) {
        ZodFormValidationDisplay(JSON.parse(error));
        return;
    }

    element.classList.remove('steps--active');
    nextElement?.classList.add('steps--active');
}


function Initialize()
{
    const steps = document.querySelectorAll('.steps .btn-next');
    steps?.forEach(item => item.addEventListener('click', NextStep));
    
}

Initialize();

export function ValidateForm(event: Event)
{
    const response = grecaptcha.getResponse();
        
    if (response != "")
    {
        const form = event.currentTarget as HTMLFormElement;
        GenericZodSchemaFormValidation<typeof writingCentreSchema>(form, writingCentreSchema, event);
        return;
    }

    event.preventDefault();
    alert('Please check I am not a robot.');
}